<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        class="inserirColabButton"
        @click="dialog = true"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="mr-2" color="primary">mdi-plus</v-icon>
        <span class="inserirColabButton__label">Novo cronômetro</span>
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-timer-outline</v-icon>
        <div>
          <span class="sc-modal__title">Adicionar cronômetro</span>
          <span class="sc-modal__subtitle">Crie um novo cronômetro para a produção</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Título</label>
          <v-text-field
            solo flat dense
            hide-details="auto"
            placeholder="Título do cronômetro..."
            v-model="dsc_titulo"
            background-color="surface_tertiary"
          />
        </div>

        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Descrição</label>
          <v-textarea
            solo flat dense
            hide-details="auto"
            no-resize
            placeholder="Descrição opcional..."
            rows="3"
            v-model="dsc_descricao"
            background-color="surface_tertiary"
          />
          <span class="char-counter">{{ dsc_descricao.trim().length }}</span>
        </div>

        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Tempo</label>
          <div class="time-picker">
            <div class="time-unit">
              <v-btn icon small class="time-btn" @click="incrementTime('hours')">
                <v-icon small>mdi-chevron-up</v-icon>
              </v-btn>
              <span class="time-value">{{ hours < 10 ? `0${hours}` : `${hours}` }}</span>
              <v-btn icon small class="time-btn" @click="decrementTime('hours')">
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
              <span class="time-label">h</span>
            </div>
            <span class="time-separator">:</span>
            <div class="time-unit">
              <v-btn icon small class="time-btn" @click="incrementTime('minutes')">
                <v-icon small>mdi-chevron-up</v-icon>
              </v-btn>
              <span class="time-value">{{ minutes < 10 ? `0${minutes}` : `${minutes}` }}</span>
              <v-btn icon small class="time-btn" @click="decrementTime('minutes')">
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
              <span class="time-label">m</span>
            </div>
            <span class="time-separator">:</span>
            <div class="time-unit">
              <v-btn icon small class="time-btn" @click="incrementTime('seconds')">
                <v-icon small>mdi-chevron-up</v-icon>
              </v-btn>
              <span class="time-value">{{ seconds < 10 ? `0${seconds}` : `${seconds}` }}</span>
              <v-btn icon small class="time-btn" @click="decrementTime('seconds')">
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
              <span class="time-label">s</span>
            </div>
          </div>
        </div>
      </div>

      <div class="sc-modal__footer">
        <v-btn text class="modal-btn-cancel" @click="close">Cancelar</v-btn>
        <v-btn color="primary" class="modal-btn-confirm" :loading="loading" @click.prevent="inserirCronometro">
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      dialog: false,
      dsc_titulo: "",
      dsc_descricao: "",
      loading: false,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  props: {
    cod_producao: Number,
  },
  computed: {
    ...mapGetters({
      cod_pasta: "pastas/getterCodPasta",
    }),
  },
  mounted() {},
  methods: {
    ...mapActions({
      getCronometrosProducao: "cronometros/getCronometrosByProducao",
    }),
    async inserirCronometro() {
      if (!this.dsc_titulo) {
        this.$toast.warning("Insira o titulo do cronômetro");
        return;
      }
      const hours = this.hours < 10 ? `0${this.hours}` : this.hours;
      const minutes = this.minutes < 10 ? `0${this.minutes}` : this.minutes;
      const seconds = this.seconds < 10 ? `0${this.seconds}` : this.seconds;
      await apiClient
        .post("cronometro", {
          cod_producao: this.cod_producao,
          tempo: `${hours}:${minutes}:${seconds}`,
          dsc_titulo: this.dsc_titulo,
          dsc_descricao: this.dsc_descricao,
        })
        .then(async () => {
          this.$toast.success("Cronômetro criado com sucesso.");
          this.close();
          await this.getCronometrosProducao({
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            flg_favorita: this.$store.state.cronometros.flg_favorita,
            filtro_texto: this.$store.state.cronometros.filtroCronometros,
            cod_pasta: null,
            size: 5,
            page: this.$store.state.cronometros.cronometrosProducao.currentPage,
          });
        })
        .catch((error) => {
          this.$toast.error("Erro ao criar cronômetro");
          console.error(error);
        });
    },
    incrementTime(timeType) {
      if (timeType === "hours") {
        this.hours += 1;
      } else if (timeType === "minutes") {
        this.minutes += 1;
        if (this.minutes === 60) {
          this.hours += 1;
          this.minutes = 0;
        }
      } else {
        this.seconds += 1;
        if (this.seconds === 60) {
          this.minutes += 1;
          this.seconds = 0;
        }
      }
    },
    decrementTime(timeType) {
      if (timeType === "hours") {
        if (this.hours > 0) {
          this.hours -= 1;
        }
      } else if (timeType === "minutes") {
        if (this.minutes > 0) {
          this.minutes -= 1;
        }
      } else {
        if (this.seconds > 0) {
          this.seconds -= 1;
        }
      }
    },
    close() {
      this.$emit("close");
      this.dialog = false;
      this.clearFormData();
    },
    openChooseFileDialog() {
      const chooseMidiaElement = document.getElementsByClassName("chooseMidia");
      const vFIleInputElement = document.getElementById("uploadAvatar");
      chooseMidiaElement.onclick = function () {
        vFIleInputElement.click;
      };
    },
    clearFormData() {
      this.dsc_titulo = "";
      this.dsc_descricao = "";
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    },
  },
  watch: {
    // dsc_data_colaboracao: function (newValue) {
    //   if(newValue) {
    //     this.convertTwitterDateToDatetime(newValue)
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
// Modal structure comes from _modal.scss (sc-modal__*).
// Scoped styles below are component-specific: activator button, char counter, time picker.

.inserirColabButton {
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  padding: 0 12px !important;

  &__label {
    color: var(--v-primary-base);
    font-size: var(--sc-text-lg);
    font-weight: var(--sc-weight-bold);
  }

  &:hover {
    background: rgba(var(--sc-color-primary-rgb), 0.08) !important;
  }
}

.char-counter {
  font-size: 0.75rem;
  color: var(--v-text_secondary-base);
  opacity: 0.6;
  text-align: right;
}

/* Time picker */
.time-picker {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 0;
  background: var(--sc-surface-tint-subtle);
  border: 1px solid var(--sc-border-subtle);
  border-radius: var(--sc-radius-lg);
}

.time-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.time-btn {
  background: var(--sc-surface-tint-hover) !important;
  transition: all var(--sc-duration-fast) var(--sc-easing-standard);

  &:hover {
    background: rgba(var(--sc-color-primary-rgb), 0.15) !important;
    .v-icon { color: var(--v-primary-base) !important; }
  }
}

.time-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--v-text_primary-base);
  font-family: monospace;
  line-height: 1;
  min-width: 60px;
  text-align: center;
}

.time-separator {
  font-size: 2rem;
  font-weight: 700;
  color: var(--v-text_secondary-base);
  opacity: 0.4;
  align-self: center;
}

.time-label {
  font-size: 0.7rem;
  color: var(--v-text_secondary-base);
  opacity: 0.5;
  text-transform: uppercase;
  letter-spacing: 1px;
}

</style>
